/**
 * Smart API URL utility for handling both preview and production environments
 * 
 * In preview environments: Uses REACT_APP_BACKEND_URL from .env
 * In production with custom domains: Uses relative URLs (same domain)
 */

const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL || '';
  const currentHost = typeof window !== 'undefined' ? window.location.hostname : '';
  
  // If we're on a custom domain (not emergentagent.com), use relative URLs
  // This ensures production deployments with custom domains work correctly
  if (currentHost && !currentHost.includes('emergentagent.com') && !currentHost.includes('localhost')) {
    return ''; // Use relative URLs for production custom domains
  }
  
  // Otherwise, use the environment variable (for preview/development)
  return envUrl;
};

export const API_URL = getApiUrl();
export default API_URL;
